import React from 'react';
import { Image, StyleSheet, View } from '@react-pdf/renderer';
import { OperationType } from 'components/RecordsListView/constants';
import { OrientationOptions } from 'screens/Applications&WorkOrders/Hooks/useOperationPdf';
import Table from '../Table';
import FlexTable from '../FlexTable';
import { mapDetailsToTable } from '../../helpers/tableConfigs/detailsTableConfig';
import { getApplicatorTableRows } from '../../helpers/tableConfigs/applicatorsTableConfig';
import { OperationPDFData } from '../..';
import { en, Locale } from '../../locales';

const styles = StyleSheet.create({
  applicationDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4
  },
  applicationDetails: {
    flex: 1
  },
  imageContainer: {
    position: 'relative',
    flex: 1,
    marginLeft: 4
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  fieldText: {
    fontFamily: 'Noto Sans',
    fontSize: 9
  },
  fieldTitle: {
    color: '#363948',
    lineHeight: 2
  },
  fieldValue: {
    color: '#14151C',
    fontWeight: 'medium'
  }
});

interface ApplicationDetailsProps {
  application: OperationPDFData;
  operationType: OperationType;
  locale: Locale;
  headerContinuedText: string;
  orientation: OrientationOptions;
}

const ApplicationDetails: React.FC<ApplicationDetailsProps> = ({
  application,
  operationType,
  locale = en,
  headerContinuedText,
  orientation
}) => {
  return (
    <View>
      <View style={styles.applicationDetailsContainer}>
        {/* Details Table */}
        <View style={styles.applicationDetails}>
          <Table
            title={locale.details.title}
            bodyItems={mapDetailsToTable(application, locale, operationType)}
          />
        </View>
        {/* Map Image */}
        <View style={styles.imageContainer}>
          {application.mapImage && (
            <Image src={application.mapImage} style={styles.image} />
          )}
        </View>
      </View>
      {/* Applicators Table */}
      <FlexTable
        headerText={locale.applicators.title}
        tableRows={getApplicatorTableRows(
          application.applicators,
          locale,
          operationType,
          orientation
        )}
        continuedText={locale.applicators.continued}
        headingStyles={{ minHeight: 22 }}
        cellBordered={operationType === OperationType.WORK_ORDER}
        headerContinuedText={headerContinuedText}
      />
    </View>
  );
};

export default ApplicationDetails;
